import React from 'react';
import { CheckboxProps } from '../../../types/DesignSystem/Checkbox';
import Typography from '../Typography/Typography';

const Checkbox: React.FC<CheckboxProps> = ({
  label,
  checked,
  onChange,
  disabled = false,
  indeterminate = false,
  className = '',
}) => {
  return (
    <div className={`tw-flex tw-items-center tw-gap-3 ${className}`}>
      <div
        className={`tw-w-5 tw-h-5 tw-border-2 tw-rounded tw-flex tw-items-center tw-justify-center tw-transition-colors ${
          checked || indeterminate
            ? 'tw-bg-white tw-border-blue-900'
            : 'tw-bg-white tw-border-grey-500'
        } ${
          disabled
            ? 'tw-opacity-50 tw-cursor-not-allowed'
            : 'hover:tw-bg-blue-100 hover:tw-border-blue-900 tw-cursor-pointer'
        }`}
        onClick={() => !disabled && onChange(!checked)}
        role="checkbox"
        aria-checked={indeterminate ? 'mixed' : checked}
        aria-label={label}
      >
        {checked && (
          <svg
            className="tw-w-3 tw-h-3 tw-text-blue-900"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fillRule="evenodd"
              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
              clipRule="evenodd"
            />
          </svg>
        )}
        {indeterminate && (
          <div className="tw-w-2 tw-h-0.5 tw-bg-blue-900" />
        )}
      </div>
      <Typography variant="body-primary" className="tw-text-grey-900">
        {label}
      </Typography>
    </div>
  );
};

export default Checkbox;
